/**
 * Author: Andrey Morozov
 * Confidential. Proprietary code. Do not distribute without authorization.
 *
 * KnowledgePage.tsx — Knowledg\1 \2age (services/operator-web-app).
 */

/**
 * Knowledge: reference materials, scripts, scenarios.
 * E4-S1: Minimal page with empty state until content or CMS is available.
 */
import { useTranslation } from '@/i18n';

export function KnowledgePage() {
  const t = useTranslation();
  return (
    <div className="py-6 space-y-6">
      <h1 className="text-lg font-semibold" style={{ color: 'var(--text-primary)' }}>
        {t('knowledge.title')}
      </h1>

      <section
        className="rounded-lg border p-6 text-center glass-panel"
        aria-label={t('knowledge.materials')}
      >
        <div className="max-w-sm mx-auto space-y-2">
          <p className="text-sm" style={{ color: 'var(--text-muted)' }} aria-hidden="true">
            {t('knowledge.empty')}
          </p>
          <p className="text-xs" style={{ color: 'var(--text-muted)' }}>
            {t('knowledge.description')}
          </p>
        </div>
      </section>
    </div>
  );
}
